import {BackendError} from './backend-error';

export class UnhandledBackendError extends BackendError {
  public autoNavigated: boolean = false;
}
